import React, { useState } from 'react';
import { Tooltip } from 'antd';
import styles from './style.less';
import CopyableText from '@/components/CopyableText';
import type { CReactCSS } from '@bluevision/tools';

type Props = {
  // handle history code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
  style?: CReactCSS;
  // handle history code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  copyable?: boolean;
};

const TextOverflow: React.FC<Props> = (props) => {
  const { children, style, value, copyable } = props;

  const [visible, setVisible] = useState<boolean>(false);

  // handle history code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onMouseEnter = (e: any) => {
    const { target } = e;
    const containerLength = target.offsetWidth; // 当前容器的宽度
    const textLength = target.scrollWidth; // 当前文字（包括省略部分）的宽度
    if (textLength > containerLength && !visible) {
      setVisible(true);
    }
    if (textLength <= containerLength && visible) {
      setVisible(false);
    }
  };

  return (
    <Tooltip
      placement='top'
      title={visible ? copyable ? <CopyableText value={value} /> : value : undefined}
    >
      <div style={style} onMouseEnter={onMouseEnter} className={styles.overflow}>
        {children || value}
      </div>
    </Tooltip>
  );
};
export default TextOverflow;
